import { render } from "./EditProdColisPage.vue?vue&type=template&id=92fcd2a2&ts=true"
import script from "./EditProdColisPage.vue?vue&type=script&lang=ts"
export * from "./EditProdColisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__